import { useState } from 'react'

import { GET_DOMAIN } from 'features/inventory/api/queries/domain'
import { domainFromDTO } from 'features/inventory/mappers/domain'
import { Domain } from 'features/inventory/types/domain'
import { useAbility } from 'providers/casl'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { Data, UseGetDomain, UseGetDomainProps, Variables } from './types'

export const useGetDomain = ({ id }: UseGetDomainProps): UseGetDomain => {
  const ability = useAbility()
  const [domain, setDomain] = useState<Domain>()

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { node: domain } = data

      if (domain) {
        setDomain(domainFromDTO(domain))
      }
    },
    options: {
      enabled: id !== undefined,
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
    },
    query: GET_DOMAIN({ ability }),
    variables: { id: id! },
  })

  return { domain, loading }
}
